import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {OngoingRequestTrackerService, SessionService} from '@core';

import {GeneralTaskUpdateResult, TaskUpdate, GeneralTaskUpdate, PatientTasksUpdateResult} from 'planner-shared';

import {StopOptimizationHttpParams} from '../../interceptors/stop-optimization-http-params';
import {AdminTaskUpdate} from "../../models/admin-task-update.model";
import {AdminTaskUpdateResult} from "../../models/admin-task-update-result.model";
import {GeneralTaskDataUpdate} from '../../models/general-task-data-update.model';
import {GeneralTaskDataUpdateResult} from "../../models/general-task-data-update-result.model";

@Injectable({providedIn: 'root'})
export class TaskUpdateService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);
    private readonly ongoingRequestTracker = inject(OngoingRequestTrackerService);


    public updatePatientTask(task: TaskUpdate): Observable<PatientTasksUpdateResult> {
        return this.updatePatientTasks([task], true);
    }

    public updatePatientTasks(tasks: TaskUpdate[], reoptimize?: boolean): Observable<PatientTasksUpdateResult> {
        const url = `${this.sessionService.getApiUrl()}/update_patient_tasks/`;
        const body = {
            requestId: this.sessionService.requestId,
            taskUpdates: JSON.parse(JSON.stringify(tasks))
        };
        return this.httpClient.put<PatientTasksUpdateResult>(url, body, {
            params: new StopOptimizationHttpParams(reoptimize).getHttpParams()
        });
    }

    public updateGeneralTasks(generalTaskUpdate: GeneralTaskUpdate): Observable<GeneralTaskUpdateResult> {
        const url = `${this.sessionService.getApiUrl()}/update_general_tasks_v2/${this.sessionService.requestId}`;
        const body = JSON.parse(JSON.stringify(generalTaskUpdate));
        return this.httpClient.put<GeneralTaskUpdateResult>(url, body, {params: new StopOptimizationHttpParams(true).getHttpParams()});
    }

    public updateAdministrativeTasks(adminTasksUpdate: AdminTaskUpdate[]): Observable<AdminTaskUpdateResult> {
        const url = `${this.sessionService.getApiUrl()}/admin_tasks/${this.sessionService.requestId}`;
        const body = {
            adminTasks: adminTasksUpdate,
        };
        const requestOptions = this.ongoingRequestTracker.createTrackingEnabledRequestOptions();

        return this.httpClient.put<AdminTaskUpdateResult>(url, body, requestOptions);
    }

    public updateGeneralTaskData(generalTaskDataUpdate: GeneralTaskDataUpdate): Observable<GeneralTaskDataUpdateResult> {
        const url = `${this.sessionService.getApiUrl()}/update_general_task_data/${this.sessionService.requestId}`;
        const body = JSON.parse(JSON.stringify(generalTaskDataUpdate));
        return this.httpClient.put<GeneralTaskDataUpdateResult>(url, body, {params: new StopOptimizationHttpParams(true).getHttpParams()});
    }
}
